import React from 'react';
import UserButton from '../UserButton';
import jwtDecode from 'jwt-decode'
import { Row, Col,Dropdown,Button,Menu,message } from 'antd';
import { Link } from "react-router-dom";
import {
    ShoppingCartOutlined,DownOutlined, CheckOutlined, MenuOutlined,
    SettingOutlined
} from '@ant-design/icons';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
    CognitoState,
} from 'react-cognito';
import AlertModal from '../AlertModal';
import AddCustomerModal from '../CustomerComponents/AddCustomerModal/AddCustomerModal';
import CustomerSwitchModal from './CustomerSwitchModal';
import axios from 'axios';
import ENVIRONMENT from '../../../environments';
import FileConstants from '../../../FileConstants';
import "./CustomHeader.scss";

const SHOPIFY_AUTHORIZED = localStorage.getItem('shopify_authorized') == 'true' ? true : false;

const right_header_style = {
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "flex-end",
    "alignItems": "center",
}
let login_type = -1;
function GetMainViewContentFromGroup(user, state) {
    var groups = ['Customer'];
    const token = localStorage.getItem('modified_super_admin_token')
    if (state === CognitoState.LOGGED_IN || state === CognitoState.LOGGING_IN) {
        if(token){
            const decoded = jwtDecode(token);
            if(decoded['cognito:groups'])
              groups = decoded['cognito:groups']
          }
          else{
          if (
            user &&
            user['signInUserSession'] &&
            user['signInUserSession']['idToken'] &&
            user['signInUserSession']['idToken']['payload'] &&
            'cognito:groups' in user['signInUserSession']['idToken']['payload']
          ) {
                groups = user['signInUserSession']['idToken']['payload']['cognito:groups'];
            }
          }
    }
    if (groups.indexOf('Admin') != -1) {
       return 0;
    }

    if (groups.indexOf('Artist') != -1) {
        return 1;
    }

    if (groups.indexOf('Customer') != -1 || groups.indexOf('MSProvider') != -1) {
        return 2;
    }

    if (groups.indexOf("TestArtist") != -1) {
        return 3;
    }
    
    if (groups.indexOf("SuperAdmin") != -1){
      return 4
    }


    return login_type;
}


class CustomHeaderView extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            collapsed: false,
            show: true,
            user_type: -1,
            customers: [],
            credit_card_missing: false,
            card_status: '',
            amazon_authorized: false,
            customerSwitchModal: false
        };
    }

    componentDidMount() {

        let login_type =  GetMainViewContentFromGroup(this.props.user, this.props.state);
        this.setState({
            user_type: login_type
        });

        //importing from FileConstants was yeilding incorrect result so that's why added this check here
        if (localStorage.getItem("is_msprovider") == 'true' || login_type == 4 || localStorage.getItem('super_admin_username')) {
          let username = localStorage.getItem('username')
          if(localStorage.getItem('super_admin_username')){
            username = localStorage.getItem('super_admin_username')
          }  
          this.loadManagedServiceUsers(username);
        } 
        let sequence_ids = localStorage.getItem('sequence_ids');
        if (login_type == 2 && !sequence_ids) {
            this.loadSequenceIDs();
        }
        this.loadAmazonAuthorizedUser();
      this.loadWalmartAuthorizedUser();
      this.loadShopifyAuthorizedUser();
        this.checkSuperAdminTokenExpiry()
    }

    clearLocalStorage = () => {
      localStorage.removeItem("all3d_jwt_token");
      localStorage.removeItem("modified_super_admin_token")
      localStorage.removeItem("super_admin_username");
      localStorage.removeItem("super_admin_expiry_token");
      localStorage.removeItem("company_name");
      localStorage.removeItem("shared_entities");
      localStorage.removeItem("username");
      localStorage.removeItem("company_id");
      localStorage.removeItem('sequence_ids')
      localStorage.removeItem('amazon_authorized');
      localStorage.removeItem('user_email');
      localStorage.removeItem('is_ai_customer');
      localStorage.removeItem('has_props');
      localStorage.removeItem('has_inspirations');
    }

    checkSuperAdminTokenExpiry = () => {
      let token = localStorage.getItem('super_admin_expiry_token')
      if (!token){
        return; // No token, no need to check
      }
      const decoded = jwtDecode(token);
      if (decoded.exp < Date.now() / 1000) {
        // Token has expired, log out the user
        console.log('logging out user from assumed role')
        this.clearLocalStorage()
        message.info("Your session has timed out. Please select the desired customer again.")
        setTimeout(() => window.location.href = '/', 2000)
      }
    };

  loadAmazonAuthorizedUser = () => {
    let payload = {
      'customer_username': localStorage.getItem('username'),
      'company_id': localStorage.getItem('company_id'),
      'action': 'get_amz_seller_customers'
    }
    axios.post(ENVIRONMENT.GET_AMZ_SELLER_CUSTOMERS, payload)
      .then((res) => {
        console.log("res", res)
        if (res.data?.status == 200) {
          if (res.data.body.length > 0) {
            localStorage.setItem('amazon_authorized', 'true');
          }
        }
      })
      .catch(err => {
        console.log("Error", err);
      })
  }

  loadWalmartAuthorizedUser = () => {
    axios.post(ENVIRONMENT.IS_WALMART_AUTHORIZED, {
      username: localStorage.getItem("username")
    })
      .then(response => {
        console.log(response);
        const isAuthorized = response.data.is_authorized;
        localStorage.setItem('walmart_authorized', isAuthorized ? 'true' : 'false');
      })
      .catch(error => {
        console.error("Error checking Walmart authorization", error);
      });
  }

  loadShopifyAuthorizedUser = () => {
    axios.post(ENVIRONMENT.IS_SHOPIFY_AUTHORIZED, {
      username: localStorage.getItem("username")
    })
      .then(response => {
        console.log(response);
        const shop = response.data.shop;
        if (shop) {
          localStorage.setItem('shopify_authorized', "true");
          localStorage.setItem('shopify_shop', shop);
        }
      })
      .catch(error => {
        console.error("Error checking Walmart authorization", error);
      });
  }

    loadManagedServiceUsers = (username) => {
        axios.post(ENVIRONMENT.GET_MANAGED_SERVICE_RELATION,{
            designer_username: username
        }).then(res => {
            let customer_data_arr = {}
            if (res.data) {
                customer_data_arr = res.data.reduce((acc, customer) => {
                  if (!acc[customer.company_id]) {
                    acc[customer.company_id] = {
                      company_name: customer.company_name,
                      customers: []
                    };
                  }
                  acc[customer.company_id].customers.push(customer);
                  return acc;
                }, {});
                console.log('customers = ', customer_data_arr)
                Object.keys(customer_data_arr).forEach(companyId => {
                  customer_data_arr[companyId].customers.sort((a, b) =>
                    a.customer_username.localeCompare(b.customer_username)
                  );
                });
                let sorted_array = Object.entries(customer_data_arr).sort(
                  ([, a], [, b]) => a.company_name.localeCompare(b.company_name)
                );

                console.log('customers = ', sorted_array)
                this.setState({
                    customers: sorted_array
                })
            }

        })
    }

    loadSequenceIDs = () => {
        let payload = {
            'username': localStorage.getItem('username'),
            'action': 'get_sequence_ids'
        };
        let company_id = localStorage.getItem('company_id');
        if (company_id) {
            payload['company_id'] = company_id;
            payload['shared_entities'] = localStorage.getItem('shared_entities');
        }
        axios.post(ENVIRONMENT.ENTITY_ORGANIZER, payload)
        .then(res => {
            if (res.data && res.data.length > 0) {
                localStorage.setItem('sequence_ids', JSON.stringify(res.data))
            }
        });
    }

    toggle = () => {
        this.setState({
            collapsed: !this.state.collapsed,
        });
        this.props.toggleMethod();
    };

    openModal = () => {
        window.location.href = "/home/?step_no=0";
    }

    viewStore = () => {
        window.location.href = '/store';
    }

    switchToDefault = () => {
        localStorage.removeItem("managed_customer_username");
        localStorage.removeItem("managed_company_id");
        localStorage.removeItem("managed_customer_email");
        localStorage.removeItem("managed_company_name");
        localStorage.removeItem("managed_shared_entites");

        message.success('User set to default!')
        window.location.reload()

    }

    handleAssign = (customer) => {
        localStorage.setItem("managed_customer_username",customer.customer_username);
        if (customer.company_id) {
            localStorage.setItem("managed_company_id",customer.company_id);
        } else {
            localStorage.removeItem("managed_company_id");
        }
        if (customer.shared_entities) {
          localStorage.setItem("managed_shared_entites",customer.shared_entities);
        } else {
          localStorage.removeItem("managed_shared_entites");
        }
        localStorage.setItem("managed_customer_email",customer.customer_email);

        if (customer.company_name) {
          localStorage.setItem("managed_company_name",customer.company_name);
        } else {
          localStorage.removeItem("managed_company_name")
        }
      
        message.success('Customer set as ' + customer.customer_username);
        window.location.reload();
    }

    assumeSuperAdminRole = () => {
      let super_admin_username = localStorage.getItem('super_admin_username')
      this.clearLocalStorage()
      localStorage.setItem('username', super_admin_username)
      window.location.href = '/'
    }

    assumeCustomerRole = (customer_username) => {
      let payload = {
        'required_user': customer_username,
        'authorization_token': localStorage.getItem('all3d_jwt_token')
      }
      axios.post(ENVIRONMENT.VERIFY_ADMIN_AND_GET_USER_DETAILS, payload)
      .then(res => {
        if(res && res.data.statusCode == 200){
          if(localStorage.getItem('super_admin_username') == undefined)
            localStorage.setItem('super_admin_username', localStorage.getItem('username'))
          localStorage.setItem('modified_super_admin_token', res.data.all3d_jwt_token)
          // localStorage.setItem('all3d_jwt_token',  res.data.all3d_jwt_token)
          console.log("*****", res.data.user_details)
          localStorage.setItem('username', res.data.user_details.username)
          localStorage.setItem('company_id', res.data.user_details.company_id)
          localStorage.setItem('shared_entities', res.data.user_details.shared_entities)
          localStorage.setItem('customer_company', res.data.user_details.customer_company)
          localStorage.setItem('user_email', res.data.user_details.email)

          localStorage.setItem('super_admin_expiry_token', res.data.token)
          localStorage.removeItem('is_ai_customer')
          localStorage.removeItem('sequence_ids')
          message.success('Customer set as ' + customer_username);
          window.location.href = '/home';
        }
      })
    }

    openCreditCardMissingModal = () => {
        this.setState({
            credit_card_missing: true
        });
    }

    closeCreditCardMissing = () => {
        this.setState({
            credit_card_missing: false
        });
    }

    goToAccountDetails = () => {
        window.location.href = "/account-details"
    }

  goToSettings = (e) => {
    if (e.key == 0) {
      window.location.href = "/account-details?tab=subs"
    } else if (e.key == 1) {
      window.location.href = "/account-details?tab=profile"
    } else if (e.key == 2) {
      window.location.href = "/account-details?tab=billing"
    } else if (e.key == 3) {
      window.location.href = "/account-details?tab=payment"
    } else if (e.key == 4) {
      window.location.href = "/groups"
    } else if (e.key == 5) {
      window.location.href = "/account-details?tab=company-users"
    } else if (e.key == 6) {
      window.location.href = "/integrations"
    }  else if (e.key == 7) {
      window.location.href = "/account-usage"
    } else if (e.key == 8) {
      window.location.href = "/email-settings"
    }
  }

    mobileMenu = (
      <Menu>
        <Menu.Item>logout</Menu.Item>
      </Menu>
    );

    render() {
      const store_options = () => {
        return <Menu>
          <Menu.Item key="1" className='manrope f-14 w-400' onClick={() => { window.location.href = '/store?item_type=products' }}>
            <span>Product models</span>
          </Menu.Item>
          <Menu.Item key="2" className='manrope f-14 w-400' onClick={() => { window.location.href = '/store?item_type=spaces' }}>
            <span>Space models</span>
          </Menu.Item>
          <Menu.Item key="3" className='manrope f-14 w-400' onClick={() => { window.location.href = '/store?item_type=scenes' }}>
            <span>Scene templates</span>
          </Menu.Item>
          <Menu.Item key="4" className='manrope f-14 w-400' onClick={() => { window.location.href = '/store?item_type=brands' }}>
            <span>Brands</span>
          </Menu.Item>
        </Menu>
      };

      const support_options = () => {
        return <Menu>
           <Menu.Item key="1" className='manrope f-14 w-400' onClick={() => { window.open(`${ENVIRONMENT.LANDING_PAGE_LINK}how-all3d-works`, '_blank') }}>
            <span>Tutorials</span>
          </Menu.Item>
          <Menu.Item key="1" className='manrope f-14 w-400' onClick={() => { window.open(`${ENVIRONMENT.LANDING_PAGE_LINK}faqs`, '_blank') }}>
            <span>FAQs</span>
          </Menu.Item>
          <Menu.Item key="2" className='manrope f-14 w-400' onClick={() => { window.open(`${ENVIRONMENT.LANDING_PAGE_LINK}contact-us`, '_blank') }}>
            <span>Contact us</span>
          </Menu.Item>
        </Menu>
      };

      const setting_options = () => {
        return <Menu>
          <Menu.SubMenu key="6" title={<span className='manrope f-14 w-400'>Integrations</span>}>
            <Menu.Item key="6-1" onClick={() => window.location.href = "/integrations"}>
              <span className='manrope f-14 w-400'>View integrations</span>
            </Menu.Item>
            {SHOPIFY_AUTHORIZED && 
            <Menu.Item key="6-2" onClick={() => window.location.href = "/shopify-job-status"}>
                <span className='manrope f-14 w-400'>Shopify bulk uploads</span>
            </Menu.Item>}
          </Menu.SubMenu>
          <Menu.Item key="7" onClick={this.goToSettings}>
            <span className='manrope f-14 w-400' >Usage history</span>
          </Menu.Item>
          <Menu.Item key="4" onClick={this.goToSettings}>
            <span className='manrope f-14 w-400' >Groups</span>
          </Menu.Item>
          {(this.state.user_type == 4 || this.state.user_type == 0) && (
            <Menu.Item key="8" onClick={this.goToSettings}>
              <span className='manrope f-14 w-400' >Email Settings</span>
            </Menu.Item>
          )}
        </Menu>
      };

  
      const menu = (
        <Menu style={{ width: "230px", maxHeight: 400, overflowY: 'auto' }}>
          {(localStorage.getItem("is_msprovider") === 'true' && (localStorage.getItem('managed_customer_username') !== null || localStorage.getItem('managed_company_id') !== null)) && (
            <>
              <Menu.Item key="0" onClick={this.switchToDefault}>
                <div className="manrope f-14 black-55">Default User</div>
              </Menu.Item>
              <Menu.Divider />
            </>
          )}
          {this.state.customers.map(([companyId, companyData], companyIndex) => (
            <Menu.SubMenu key={`company-${companyIndex}`} title={companyData.company_name}>
              {companyData.customers.map((customer, customerIndex) => (
                <Menu.Item key={`customer-${companyIndex}-${customerIndex}`} onClick={() => this.handleAssign(customer)}>
                  <div className="manrope f-14 black-14 justify-space-between">
                    <span>{customer.customer_username.startsWith('Google') ? customer.customer_email.split('@')[0] : customer.customer_username}</span>
                    <span>{localStorage.getItem('managed_customer_username') === customer.customer_username ? <CheckOutlined /> : ''}</span>
                  </div>
                </Menu.Item>
              ))}
            </Menu.SubMenu>
          ))}
          {this.state.customers.length === 0 && (
            <Menu.ItemGroup title={<span className="manrope f-14 black-55">No customers assigned yet!</span>} />
          )}
        </Menu>
      );

        const superAdminCustomersMenu = (
          <Menu style={{ width: "230px", maxHeight: 400, overflowY: 'auto' }}>
              {localStorage.getItem("super_admin_username") ?
              <>
                  <Menu.Item key={0}  onClick={this.assumeSuperAdminRole}>
                      <div className="manrope f-14 black-55">Default User</div>
                  </Menu.Item>
                  <Menu.Divider />
              </>: ''}
              {this.state.customers.map(([companyId, companyData], companyIndex) => (
                <Menu.SubMenu key={`company-${companyIndex}`} title={companyData.company_name}>
                  {companyData.customers.map((customer, customerIndex) => (
                    <Menu.Item key={`customer-${companyIndex}-${customerIndex}`} onClick={() => this.assumeCustomerRole(customer.customer_username)}>
                      <div className="manrope f-14 black-14 justify-space-between">
                        <span>{customer.customer_username.startsWith('Google') ? customer.customer_email.split('@')[0] : customer.customer_username}</span>
                        <span>{localStorage.getItem('username') === customer.customer_username ? <CheckOutlined /> : ''}</span>
                      </div>
                    </Menu.Item>
                  ))}
                </Menu.SubMenu>
              ))}
              {this.state.customers.length === 0 && (
                <Menu.ItemGroup title={<span className="manrope f-14 black-55">No customers assigned yet!</span>} />
              )}
          </Menu>
        )
        
        return (
          <Row type="flex" justify="space-between">
            <Col span={8} style={{ display: "flex", alignItems: "center" }}>
              <a href="/home" style={{ lineHeight: "100%" }}>
                <img
                  className="home-btn"
                  src={require("../../../assets/images/new-all3d-white.svg")}
                  height="30px"
                  width="98px"
                  alt=""
                ></img>
              </a>
            </Col>

            <Col span={16} className="text-right hide-on-mobile">
              <div style={right_header_style}>
                {this.state.payment_type == "prepaid" &&
                this.state.card_status == 0 ? (
                  <div
                    className="store-button yellow text-yellow"
                    onClick={this.openCreditCardMissingModal}
                  >
                    *Credit Card Information Missing
                  </div>
                ) : (
                  ""
                )}
                {localStorage.getItem("is_msprovider") == "true" ? (
                  <AddCustomerModal />
                ) : (
                  ""
                )}
                {localStorage.getItem("is_msprovider") == "true" ? (
                  <Button
                    className="store-button store-button-text text-white"
                    ghost
                    onClick={() => this.setState({ customerSwitchModal: true })}
                  >
                    {FileConstants.MANAGED_CUSTOMER_USERNAME != undefined
                      ? (FileConstants.MANAGED_CUSTOMER_USERNAME.startsWith('Google')
                          ? localStorage.getItem('managed_customer_email').split('@')[0]
                          : FileConstants.MANAGED_CUSTOMER_USERNAME) +
                        (localStorage.getItem('managed_company_name') != undefined
                          ? ' (' + localStorage.getItem('managed_company_name') + ')'
                          : '')
                      : 'Select Customer'}
                    &nbsp;<DownOutlined />
                  </Button>
                ) : (
                  ""
                )}
                {
                  (this.state.user_type == 4 && Object.keys(this.state.customers).length > 0) || localStorage.getItem('super_admin_username') ? (
                    <Button
                      className="store-button store-button-text text-white"
                      ghost
                      onClick={() => this.setState({ customerSwitchModal: true })}
                    >
                      {localStorage.getItem('super_admin_username')
                        ? (localStorage.getItem('username').startsWith('Google')
                            ? localStorage.getItem('user_email').split('@')[0]
                            : localStorage.getItem('username')) +
                          (localStorage.getItem('user_company_name') != undefined
                            ? ' (' + localStorage.getItem('user_company_name') + ')'
                            : '')
                        : 'Select Customer'}
                      &nbsp;<DownOutlined />
                    </Button>
                  ) : ""
                }
                {/* {this.state.user_type == 2 ? 
                        <div className="store-button-text text-white store-button blue" onClick={this.openModal}>
                            Take Tour
                        </div>: ''} */}
                {this.state.user_type == 3 ? (
                  ""
                ) : localStorage.getItem('is_ai_customer') === 'true' ? (
                  ""
                ) : (
                  <Dropdown overlay={store_options} trigger={["click"]}>
                    <Button className="store-button store-button-text text-white" ghost>
                      ALL3D Store&nbsp;<DownOutlined />
                    </Button>
                  </Dropdown>
                )}

                  <Dropdown overlay={support_options} trigger={["click"]}>
                    <Button className="store-button store-button-text text-white" ghost>
                      Help&nbsp;<DownOutlined />
                    </Button>
                  </Dropdown>

                  {localStorage.getItem('is_ai_customer') !== 'true' && (
                    <Dropdown overlay={setting_options} trigger={["click"]}>
                      <Button className="store-button store-button-text text-white" style={{paddingBottom: 0}} ghost>
                        <SettingOutlined style={{fontSize: 20}}/>
                      </Button>
                    </Dropdown>
                  )}

                {/* <Notification></Notification> */}
                <UserButton user_type={this.state.user_type} />
              </div>
            </Col>
            <Col span={16} className="mobile-menu show-on-mobile">
              <UserButton user_type={this.state.user_type} />
              {/* <MenuOutlined className="menu-icon" /> */}
            </Col>
            <CustomerSwitchModal
              visible={this.state.customerSwitchModal}
              onClose={() => this.setState({ customerSwitchModal: false })}
              assignedCustomers={this.state.customers}
              isSuperAdmin={this.state.user_type == 4 || !!localStorage.getItem('super_admin_username')}
              activeUsername={
                localStorage.getItem('super_admin_username')
                  ? localStorage.getItem('username')
                  : localStorage.getItem('managed_customer_username')
              }
              onResetDefault={
                (localStorage.getItem('super_admin_username') ||
                 (localStorage.getItem('is_msprovider') === 'true' &&
                  (localStorage.getItem('managed_customer_username') !== null || localStorage.getItem('managed_company_id') !== null)))
                  ? () => {
                      localStorage.getItem('super_admin_username') ? this.assumeSuperAdminRole() : this.switchToDefault();
                    }
                  : null
              }
              onAssign={(customer) => { this.handleAssign(customer); }}
              onAssumeRole={(customer) => { this.assumeCustomerRole(customer.customer_username); }}
            />
            <AlertModal
              onCancel={this.closeCreditCardMissing}
              visible={this.state.credit_card_missing}
              heading={"Credit Card Information Missing"}
              text={
                "Your credit card information seems to be missing. In order to seemlessly proceed with your purchases on ALL3D, it is recommended that you provide your card information."
              }
              footer={[
                <div className="justify-in-center">
                  <Button
                    className="modal-okay-gray square font-14"
                    onClick={this.closeCreditCardMissing}
                  >
                    Cancel
                  </Button>
                  <Button
                    onClick={this.goToAccountDetails}
                    className="modal-okay square font-14"
                    htmlType="submit"
                  >
                    Provide Information
                  </Button>
                </div>,
              ]}
            />
          </Row>
        );
    }
}

CustomHeaderView.propTypes = {
    user: PropTypes.object,
    component: PropTypes.func,
    attributes: PropTypes.object,
    state: PropTypes.string,
};
  
const mapStateToProps = (state) => ({
    state: state.cognito.state,
    user: state.cognito.user,
    attributes: state.cognito.attributes,
});
  
const CustomHeader = connect(mapStateToProps, null)(CustomHeaderView);
  
export default CustomHeader;
